module.exports = __webpack_public_path__ + "static/img/isengrim.463910a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/isengrim.png
// module id = oIzU
// module chunks = 0